/** @jsx jsx */

import { css, jsx } from "@emotion/react";
import bgLeft from "../../../images/noissue-101-left.svg";
import bgRight from "../../../images/noissue-101-right.svg";
import { withPrefix } from "gatsby-link";
import { CarouselCommon } from "./CarouselCommon";
import WrapCardCommon from "./WrapCardCommon";

const WrapNoissue101 = ({ data }) => {
    const cards = data.filter(item => item.node.tags.some(el=>el.slug==="noissue-101")).slice(0, 10).map( (item, index) => {
        return { display:<WrapCardCommon post={item.node} id={index}/>, key: index}
    });
    return (
            <section
                css={css`
                    width: 100%;
                    position: relative;
                    background: url(${bgLeft}) bottom 22rem left / 25%,
                        url(${bgRight}) top 1rem right / 25%,
                        linear-gradient(180deg, #D9D9E3 82.16%, #F3CF73 99.25%);
                    background-repeat: no-repeat;
                    text-align: center;
                    height: 100rem;
                    padding-top: 6rem; 
                `}
            >
                <div>
                <h1 css={css`
                    color: #393972;
                    font-size: 8rem;
                    text-align: center;
                    line-height: 10rem;
                    @media(max-width: 1024px){
                        font-size: 5rem;
                        line-height: 5rem;
                    }
                `}>
                    noissue 101
                </h1>
                <p css={css`
                    margin: auto;
                    max-width: 60rem;
                    color: #616161;
                    font-size: 1.5rem;
                    line-height: 2.4rem;
                    @media(max-width: 1024px){
                        max-width: 40rem;
                    }
                `}>Learn how to get the most out of noissue with helpful design tips and inspiration, information on our products, and guides to the different communities you can be apart of! We share practical advice on all things packaging, wrapping, and sending!</p>
                <a
                    css={css`
                        font-size: 1.6rem;
                        font-weight: 400;
                        line-height: 1.6;
                        padding: 1rem 4rem;
                        color: #393972;
                        border-radius: 1rem;
                        border: 0.2rem solid #393972;
                        cursor: pointer;
                        display: inline-block;
                        margin: 2rem auto;
                    `}
                    href={withPrefix("/noissue-101/")}
                >
                    See More
                </a>

                <CarouselCommon cards={cards} maxWidth={22}/>

                </div>

            </section>
    );
};

export default WrapNoissue101;
